<script>
  import BeforeRecButton from './buttons/beforeRecButton.svelte';
  import RecordingButton from './buttons/recordingButton.svelte';
  import ReRecButton from './buttons/reRecButton.svelte';
  import PlayPauseButton from './buttons/playPauseButton.svelte';
  import { createEventDispatcher } from 'svelte';
  import { getTimerLabel } from './utils/timer';
  import { RecordingStatus, PreviewStatus } from './utils/enum';

  const dispatch = createEventDispatcher();

  export let currentRecordingStatus;
  export let currentPreviewStatus;

  const REC_TIME = 60000
  let timeLeft = REC_TIME
  let timer = null

  const clickPlayPause = () => currentPreviewStatus === PreviewStatus.PAUSE ? dispatch('playback') : dispatch('pause');

  const startCountdown = () => {
    let finishTime = new Date().getTime() + REC_TIME;
    timer = setInterval(updateTime, 10, finishTime) // 10ミリ秒ごとに更新
  }

  const updateTime = (finishTime) => {
    const now = new Date().getTime();
    timeLeft = Math.max(finishTime - now, 0);

    if (timeLeft <= 0) {
      dispatch('stopRecording')
      clearInterval(timer);
    }
  }

  $: countDownLabel = getTimerLabel(timeLeft);

  $: if (currentRecordingStatus === RecordingStatus.RECORDING) startCountdown();
    else clearInterval(timer);
</script>

<div class="w-full flex items-center justify-center pt-20 pb-11">
  {#if currentRecordingStatus === RecordingStatus.BEFORE_RECORDING}
    <BeforeRecButton on:click={() => dispatch('startRecording')} />
  {:else if currentRecordingStatus === RecordingStatus.RECORDING}
    <RecordingButton {REC_TIME} {timeLeft} on:click={() => dispatch('stopRecording')} >{countDownLabel}</RecordingButton>
  {:else if currentRecordingStatus === RecordingStatus.LOADING}
    <div class="text-white text-sm font-bold">録音した音声の読込中...</div>
  {:else if currentRecordingStatus === RecordingStatus.RECORDED}
    <div class="flex items-center gap-9">
      <ReRecButton on:click={() => dispatch('reRecording')} />
      <PlayPauseButton {currentPreviewStatus} on:click={clickPlayPause} />
      <button
        type="submit"
        class="w-20 h-10 bg-site-purple-1 rounded-[50px] flex items-center justify-center"
      >
        <span class="text-white text-xs font-bold">保存</span>
      </button>
    </div>
  {:else}
    <div class="text-site-red-2 text-sm font-bold">エラーが発生しました。画面をリロードしてください。</div>
  {/if}
</div>
